export class BusyService {
    active: number = 0;
    on() { this.active++; }
    off() { this.active--; if (this.active < 0) this.active = 0; }
}